export const config = {
  backend: {
    apiUrl: import.meta.env.VITE_API_ENDPOINT,
  },
  appStoreLink: import.meta.env.VITE_APP_STORE_LINK,
  playStoreLink: import.meta.env.VITE_PLAY_STORE_LINK,
  appEnv: import.meta.env.VITE_APP_ENV,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  appRelease: import.meta.env.VITE_APP_RELEASE,
};
